/* Copyright (c) 2020-present CloudIO Inc */

import { Item } from '../../registry/Component.type';

export const page: {
  root: Item<'Page'>;
  localDataStore: Item<'LocalDataStore'>;
  dataStoreReference: Item<'DataStoreReference'>;
  flexPanel: Item<'FlexPanel'>;
  flexItem: Item<'FlexItem'>;
  googleMap: Item<'GoogleMap'>;
} = {
  dataStoreReference: {
    children: ['flexPanel'],
    itemId: 'dataStoreReference',
    parent: 'root',
    props: {
      alias: 'googleMapHelpAlias',
    },
    type: 'DataStoreReference',
  },
  flexItem: {
    children: ['googleMap'],
    itemId: 'flexItem',
    parent: 'flexPanel',
    props: {},
    type: 'FlexItem',
  },
  flexPanel: {
    children: ['flexItem'],
    itemId: 'flexPanel',
    parent: 'dataStoreReference',
    props: {},
    type: 'FlexPanel',
  },
  googleMap: {
    children: [],
    itemId: 'googleMap',
    parent: 'flexItem',
    props: {
      latitude: 'latitude',
      longitude: 'longitude',
      markerIconHeight: 28,
      markerIconWidth: 32,
      markerLabel: 'city',
    },
    type: 'GoogleMap',
  },
  localDataStore: {
    children: [],
    itemId: 'localDataStore',
    parent: 'root',
    props: {
      alias: 'googleMapHelpAlias',
      data: 'latitude,longitude,city\n45.23,-86.43,Leland\n43.34,-94.87,Lake Mills\n41.85,-93.43,Unionville\n44.34,-88.87,Green Bay\n45.86,-92.43,Barron',
      dataSource: 'GoogleMapHelp',
    },
    type: 'LocalDataStore',
  },
  root: {
    children: ['localDataStore', 'dataStoreReference'],
    itemId: 'root',
    parent: 'root',
    props: {
      windowTitle: {
        type: 'text',
        value: 'Blank Page',
      },
    },
    type: 'Page',
  },
};
